'use client';

import React from 'react';
import Image from 'next/image';
import classes from './TestimonialCard.module.scss';

export type TestimonialSlice = {
  type: 'testimonial-card';
  badge?: string;
  title?: string;
  subtitle?: string;
  testimonials: {
    quote: string;
    name: string;
    role: string;
    company: string;
    photo?: string;
  }[];
};

export function TestimonialCard({ data }: { data: TestimonialSlice }) {
  const { badge, title, subtitle, testimonials = [] } = data;

  return (
    <section className={classes.section} aria-labelledby="testimonial-title">
      <div className={classes.container}>
        {(badge || title || subtitle) && (
          <header className={classes.header}>
            {badge && <span className={classes.badge}>{badge}</span>}
            {title && (
              <h2 id="testimonial-title" className={classes.title}>
                {title}
              </h2>
            )}
            {subtitle && <p className={classes.subtitle}>{subtitle}</p>}
          </header>
        )}

        <div className={classes.grid}>
          {testimonials.map((t, idx) => (
            <article key={idx} className={classes.card} aria-label={`Témoignage de ${t.name}`}>
              <blockquote className={classes.quote}>
                <span className={classes.quoteMark}>"</span>
                {t.quote}
              </blockquote>

              <footer className={classes.author}>
                {t.photo ? (
                  <div className={classes.photoWrap}>
                    <Image
                      src={t.photo}
                      alt={`${t.name}, ${t.role}`}
                      fill
                      sizes="64px"
                      className={classes.photo}
                    />
                  </div>
                ) : (
                  <div className={classes.photoPlaceholder}>{t.name.charAt(0)}</div>
                )}
                <div className={classes.meta}>
                  <strong className={classes.name}>{t.name}</strong>
                  <span className={classes.role}>
                    {t.role}, {t.company}
                  </span>
                </div>
              </footer>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
